module.exports = __webpack_public_path__ + "img/square-bolt.703e9d3e.svg";